import { useEffect } from 'react';
import type { OnCommitStageSettings } from '../types';
type PropsT = {
  containerRef: React.RefObject<HTMLDivElement>;
  stageRef: React.RefObject<HTMLDivElement>;
  isImageLoaded: boolean;
  onCommitStageSettingsAndApplyToDOMNodes: OnCommitStageSettings;
};
export function useSetInitialScaleOnLoad({
  containerRef,
  stageRef,
  isImageLoaded,
  onCommitStageSettingsAndApplyToDOMNodes
}: PropsT) {
  useEffect(() => {
    if (!containerRef.current || !stageRef.current || !isImageLoaded) {
      return;
    }
    const {
      width: stageWidth,
      height: stageHeight,
      top: stageTop,
      left: stageLeft
    } = stageRef.current.getBoundingClientRect();
    const {
      top: containerTop,
      left: containerLeft
    } = containerRef.current.getBoundingClientRect();
    const {
      offsetWidth: containerOffsetWidth,
      offsetHeight: containerOffsetHeight
    } = containerRef.current;
    const diffWidth = containerOffsetWidth / 2 - stageWidth / 2;
    const diffHeight = containerOffsetHeight / 2 - stageHeight / 2;
    const offsetHeight = diffHeight - stageTop + containerTop;
    const offsetWidth = diffWidth - stageLeft + containerLeft;
    const updatedScale = Math.min(containerOffsetWidth / stageWidth, containerOffsetHeight / stageHeight);
    onCommitStageSettingsAndApplyToDOMNodes({
      scale: updatedScale,
      x: offsetWidth,
      y: offsetHeight
    });
  }, [containerRef, stageRef, isImageLoaded, onCommitStageSettingsAndApplyToDOMNodes]);
}